var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7075 0.74292C5.3451 0.74292 0.1875 5.90052 0.1875 12.2629C0.1875 18.6253 5.3451 23.7829 11.7075 23.7829C18.0699 23.7829 23.2275 18.6253 23.2275 12.2629C23.2275 5.90052 18.0699 0.74292 11.7075 0.74292ZM8.8875 17.0377H6.5547V9.53052H8.8875V17.0377ZM7.7067 8.60892C6.9699 8.60892 6.4935 8.08692 6.4935 7.44132C6.4935 6.78252 6.9843 6.27612 7.7367 6.27612C8.4891 6.27612 8.9499 6.78252 8.9643 7.44132C8.9643 8.08692 8.4891 8.60892 7.7067 8.60892ZM17.4075 17.0377H15.0747V12.8773C15.0747 11.9089 14.7363 11.2513 13.8927 11.2513C13.2483 11.2513 12.8655 11.6965 12.6963 12.1249C12.6339 12.2773 12.6183 12.4933 12.6183 12.7081V17.0365H10.2843V11.9245C10.2843 10.9873 10.2543 10.2037 10.2231 9.52932H12.2499L12.3567 10.5721H12.4035C12.7107 10.0825 13.4631 9.36012 14.7219 9.36012C16.2567 9.36012 17.4075 10.3885 17.4075 12.5989V17.0377Z",
    fill: "#222835"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fc061e5c.svg";
export { ForwardRef as ReactComponent };